
import DynamicComponent from './DynamicComponent.vue'

export default {
  name: 'DynamicTemplateComponent',
  components: {
    DynamicComponent,
  },
  inheritAttrs: false,
  props: {
    node: {
      type: Object,
      default: () => ({}),
      validator: node => {
        return (
          Object.hasOwnProperty.call(node, 'template') ||
          // it should have all "component", "props", "attrs" and "children".
          // But component is the only one really mandatory...
          Object.hasOwnProperty.call(node, 'component')
        )
      },
    },
    rootElement: {
      type: String,
      default: 'div',
    },
  },
  methods: {
    renderNode({ h, node }) {
      if (!node) {
        return
      }
      // handle dynamic slots
      if (node.component && node.component.tag === 'slot') {
        return h(
          'div',
          {
            attrs: node.attrs,
          },
          [this.$slots[node.component.content]]
        )
      }
      // component with children handling
      if (node.children && node.children.length) {
        return h(
          'DynamicComponent',
          {
            props: {
              node,
            },
          },
          [...node.children.map(child => this.renderNode({ h, node: child }))]
        )
      }
      // childless component handling
      return h('DynamicComponent', {
        props: {
          node,
        },
      })
    },
    getDefaultSlot() {
      return this.$slots && this.$slots.default
    },
  },
  render(h) {
    return h(this.rootElement || 'div', [
      this.renderNode({
        h,
        node: this.node.template ? this.node.template : this.node,
      }),
      // this.getDefaultSlot(),
    ])
  },
}
